import { Component, Prop, Vue } from "vue-property-decorator";
import Card from "@/components/Card.tsx";
import { Module, TTMJ } from "@/store/enums.ts";
import UUID from "uuid/v1";
import { submitFiles } from "./StorageHandler";
import { CreateElement } from "vue";
import AudioHandler from "./Recorder";
import firebase from "firebase/app";
import { questionsCollection } from "@/firebase";
import { taskCompleted } from "./utils";
@Component
export default class TalkToMeJrORF extends Vue {
  private _componentState!: {
    storyRequested: boolean;
    cardHeight: number;
    startAutoRecording?: boolean;
    displayMessage?: boolean;
    enableNext?: boolean;
    itemIdx?: number;
    alreadyDone?: boolean;
  };

  private blob: any;
  private _timeout: number = 3000;
  private _stories?: { name: string; story: any; answer?: any }[] = [];
  private _enableAutoPlayNext!: boolean;
  private audioLoc = "/res/protected/t2mejr_instructions/ttmj_orf_autoplay.mp3";

  recordingStopped(audio: any, duration: number, blob: any) {
    if (this._componentState.itemIdx == undefined || !this._stories) return;

    this._stories[this._componentState.itemIdx].answer = blob;
    this._componentState.displayMessage = true;
    this._componentState.enableNext = true;
    this._componentState.alreadyDone = true;
    this.$forceUpdate();
  }

  async created() {
    this._componentState = {
      storyRequested: false,
      cardHeight: -1,
      displayMessage: false,
      enableNext: false,
      itemIdx: 0,
      alreadyDone: false
    };

    this._enableAutoPlayNext = false;
    this.$store.dispatch("setClip", {
      path: this.audioLoc,
      callbackFunction: () => {
        this._enableAutoPlayNext = true;
        this.$forceUpdate();
      }
    });

    this._stories = [];

    await questionsCollection
      .doc("orf")
      .get()
      .then(async query => {
        let data = query.data();
        for (let keys in data) {
          let eleStory: any[] = [];
          (data as any)[keys].forEach((el: any) => {
            eleStory.push(<p>{el}</p>);
          });
          if (!this._stories) return;
          this._stories.push({ name: keys, story: eleStory });
        }
      });

    this.$forceUpdate();
  }

  beforeDestroy() {
    this.$store.dispatch("removeClip", this.audioLoc);
  }

  mounted() {
    let elem: any = document.getElementById("ofr_orig_div");
    if (elem == null) return;

    this._componentState.cardHeight = elem.offsetHeight;
  }

  render(h: CreateElement) {
    const requestStory = () => {
      return (
        <Card title="I can read stories out loud." mod={Module.TTMJ}>
          <div slot="mainContent" id="ofr_orig_div">
            <p class="subtitle-1">
              Here are some stories for you to read out loud.
            </p>
            <p class="font-weight-bold subtitle-1">
              Please read each story clearly and at a comfortable speed. When
              you are ready, click on the start recording button and start reading
              the story.{" "}
            </p>{" "}
            <p class="font-weight-bold subtitle-1">Click "Next" to continue.</p>
          </div>

          <div slot="actions">
            <v-btn
              onClick={() => {
                this._componentState.storyRequested = true;
                this.$forceUpdate();
                setTimeout(() => {
                  this._componentState.startAutoRecording = true;
                  this.$forceUpdate();
                }, this._timeout);
              }}
              disabled={!this._enableAutoPlayNext}
              color="warning"
            >
              Next
            </v-btn>
          </div>
        </Card>
      );
    };
    const story = () => {
      if (this._stories && this._componentState.itemIdx != undefined) {
        return this._stories[this._componentState.itemIdx].story;
      }
    };
    const showStory = () => {
      if (!this._stories || this._componentState.itemIdx == undefined) return;

      return (
        <Card
          title="Click 'Start Recording', and then read the story out loud."
          mod={Module.TTMJ}
        >
          <div
            slot="mainContent"
            style={{
              height: String(this._componentState.cardHeight * 2.5) + "px",
              overflow: "auto"
            }}
          >
            <v-col class="mx-auto text-center" cols={16}>
              <AudioHandler
                recordID="orf"
                label={{
                  start: "Start Recording",
                  end: "Stop Recording"
                }}
                disableUserControl
                disabled={this._componentState.alreadyDone}
                callbackOnStop={this.recordingStopped}
              />
            </v-col>
            {
              <p
                style={{ textTransform: "capitalize" }}
                class="text-center mx-auto headline font-weight-bold"
              >
                {this._stories[this._componentState.itemIdx].name}
              </p>
            }
            {story()}
          </div>
          <div slot="actions">
            <v-container>
              <v-row class="mx-auto text-center">
                <v-col>
                  <v-btn
                    disabled={!this._componentState.enableNext}
                    onclick={this._submitStories}
                  >
                    Next
                  </v-btn>
                </v-col>
              </v-row>
            </v-container>
          </div>
        </Card>
      );
    };

    return (
      <span>
        {!this._componentState.storyRequested ? requestStory() : showStory()}
      </span>
    );
  }

  private async _submitStories() {
    if (this._componentState.itemIdx == undefined || !this._stories) {
      return;
    }

    if (this._componentState.itemIdx + 1 < this._stories.length) {
      this._componentState.itemIdx += 1;
      this._componentState.alreadyDone = false;
      this._componentState.enableNext = false;
      this.$forceUpdate();
      return;
    }
    let currentUser = firebase.auth().currentUser;

    if (!currentUser) return;

    let uid: any = UUID();

    this.$store.dispatch("addNotification", {
      type: "info",
      value: "Please wait while we upload your answers",
      timeout: -1,
      icon: "mdi-voice",
      uid: uid,
      loaderValue: 0
    });

    this._stories.forEach(async (ele, idx) => {
      if (!currentUser) return;

      await submitFiles(
        "users/" + currentUser.uid + "/t2mejr/orf/orf_" + ele.name + ".webm",
        ele.answer,
        (snapshot: any) => {
          if (!this._stories) return;
          let progress =
            ((snapshot.bytesTransferred / snapshot.totalBytes) *
              100 *
              (idx + 1)) /
            this._stories.length;
          this.$store.dispatch("updateVisibleNotification", {
            value:
              progress < 99
                ? "Please wait while we upload your answer"
                : "Successfully updated",
            type: progress < 99 ? "info" : "success",
            uid: uid,
            loaderValue: progress,
            timeout: progress < 99 ? -1 : 4000
          });

          // set task completed in firestore
          if (snapshot.bytesTransferred == snapshot.totalBytes) {
            if (!currentUser) return;
            taskCompleted(currentUser.uid, TTMJ.ORF);
          }
        }
      );
    });

    this.$router.push({
      name: "t2mejr-tasklist"
    });
  }
}

const component = TalkToMeJrORF;
